import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { IUnlockInsuranceSlice, UnlockInsuranceSurface } from './types';

const initialState: IUnlockInsuranceSlice = {
  isUnlockInsuranceModalClosed: false,
  isPlanUpgradeSubmitted: false,
  surface: 'idle',
  targetOfferCode: null,
};

const unlockInsuranceSlice = createAppSlice({
  name: 'unlockInsurance',
  initialState,
  reducers: {
    setIsUnlockInsuranceModalClosed(state, action: PayloadAction<boolean>) {
      state.isUnlockInsuranceModalClosed = action.payload;
    },
    setIsPlanUpgradeSubmitted(state, action: PayloadAction<boolean>) {
      state.isPlanUpgradeSubmitted = action.payload;
    },
    setUnlockInsuranceSurface(
      state,
      action: PayloadAction<UnlockInsuranceSurface>,
    ) {
      state.surface = action.payload;
    },
    setUnlockInsuranceTargetOfferCode(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.targetOfferCode = action.payload;
    },
    resetUnlockInsuranceSurface(state) {
      state.surface = 'idle';
      state.targetOfferCode = null;
    },
  },
});

export const {
  setIsUnlockInsuranceModalClosed,
  setIsPlanUpgradeSubmitted,
  setUnlockInsuranceSurface,
  setUnlockInsuranceTargetOfferCode,
  resetUnlockInsuranceSurface,
} = unlockInsuranceSlice.actions;
export default unlockInsuranceSlice.reducer;
